import React from "react";
import { RFPercentage } from "react-native-responsive-fontsize";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { DariaftihaScreen,MyCoursesScreen,NewCoursesScreen, AccountScreen } from "./../screens";
import TopTabNavigator from "./TopTabNavigator";


const Tab = createBottomTabNavigator();

const TabNavigator = () => {
    return (
        <Tab.Navigator
            initialRouteName="MyCoursesScreen"
            screenOptions={({ route }) => ({
                tabBarIcon: ({ focused, color, size }) => {
                    let iconName;

                    if (route.name === "Courses") {
                        iconName = "basket-unfill";
                    } else if (route.name === "Account") {
                        iconName = "basket-fill";
                    } else if (route.name === "MyCourses") {
                        iconName = "home";
                    }else if (route.name === "more") {
                        iconName = "apps";
                    }

                    return (
                        <MaterialCommunityIcons
                            name={iconName}
                            size={size}
                            color={color}
                        />
                    );
                },
            })}
            tabBarOptions={{
                activeTintColor: "tomato",
                inactiveTintColor: "gray",
                activeBackgroundColor: "light",
                labelStyle: {
                    fontFamily: "ih",
                    fontSize: RFPercentage(1.5),
                },
            }}
        >
            <Tab.Screen
                name="MyCourses"
                component={MyCoursesScreen}
                options={{
                    tabBarLabel: "خلاصه وضعیت",
                    title:"خلاصه وضعیت"
                    //tabBarBadge: 3,
                }}
            />
            <Tab.Screen
                name="Courses"
                options={{ title: 'پرداختی ها' }}
                component={NewCoursesScreen}
                options={{
                    tabBarLabel: "پرداختی ها",
                    title: "پرداختی ها",
                }}
            />
            <Tab.Screen
                name="Account"
                component={DariaftihaScreen}
                options={{
                    tabBarLabel: "دریافتی ها",
                    title: "دریافتی ها",
                }}
            />
            <Tab.Screen
                name="more"
                component={AccountScreen}
                options={{
                    tabBarLabel: "بیشتر",
                    title: "امکانات بیشتر",
                }}
            />
        </Tab.Navigator>
    );
};

export default TabNavigator;
